import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { FeatureState } from 'src/domains/layouts/config/features/featureState/FeatureState';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';

interface VirtualGamesOnHomepagePropsType {
    appCasinoState: AppCasinoState;
}

const GamesOnHomepage = ssrReactLazy(
    async () => (await import('src/domains/casino/webview/gamesOnHomepage/GamesOnHomepage')).GamesOnHomepage
);

export const VirtualGamesOnHomepage = observer('VirtualGamesOnHomepage', (props: VirtualGamesOnHomepagePropsType) => {
    const common = useCommon();
    const featureState = FeatureState.get(common);
    const configState = ConfigComponents.get(common).config;

    const { appCasinoState } = props;

    if (featureState.allowCasinoInIOSWrapperNew === false) {
        return null;
    }

    if (configState.casinoPublishedCollections.includes('virtuals') === false) {
        return null;
    }

    return (
        <GamesOnHomepage
            appCasinoState={appCasinoState}
            aspectRatio='1/1'
            collectionKey='virtuals'
        />
    );
});
